export default String.raw`
.bannerPromo {
    padding: 32px 9%;
    height: auto;
    display: flex;
    gap: 24px;
    
    @media screen and (min-width: 1440px) {
        height: auto;
    }

    &__wrapper {
        width: 100%;
        max-width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
        padding: 0;
        box-sizing: border-box;
        position: relative;

        @media screen and (min-width: 768px) {
            max-width: clamp(340px, 50vw, 720px);
            height: clamp(490px, 72.06vw, 860px);
        }
    }
    
    figure {
        margin: 0;
        width: 100%;
        height: 100%;
    }
    
    &__image {
        width: 100%;
        height: 100%;

        img {
            box-sizing: border-box;
            padding: 0;
            margin: 0 auto;
            max-width: 720px;
            max-height: 860px;
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 8px;
        }
    }

    &__image-placeholder {
        width: 100%;
        height: 100%;
        background-color: #f2f2f2;
        border-radius: 8px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;

        @media screen and (min-width: 768px) {
            height: 860px;
        }
        
        img {
            width: 100%;
            height: auto;
            object-fit: cover;
            
            @media screen and (min-width: 768px) {
                position: static; 
                transform: none;
                max-height: 860px;
            }
        }
    }

    &__texts {
        position: absolute;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 40px;
        left: 48px;
        top: 48px;
        width: calc(100% - 96px);
        max-height: calc(100% - 100px);
        border-radius: 8px;
    }
    
    &__info {
        max-width: 390px;
        width: fit-content;
    }

    &__title {
        font-size: clamp(24px, 3.35vw, 56px);
        line-height: clamp(32px, 4vw, 56px);
        font-weight: 600;
        color: $bannerPromotionalFontColor;
        display: block;
        text-overflow:ellipsis;
        overflow: hidden;
        -webkit-box-orient: vertical;

        &.bannerPromo__title__small {
            line-height: 1.5;
            font-size: 24px;
            margin-top: 10px;
            font-weight: 300;
            color: $bannerPromotionalFontColor;
        }
    }

    &__text {
        color: $bannerPromotionalFontColor;
        margin: .8rem 0 0;
        padding: 0;
    }
    
    &__placeholder {
        position: absolute;
        font-size: clamp(24px, 3.57vw, 30px);
        color: #6c6c6c;
        text-align: center;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        margin: 0;

        &::after {
            content: 'Desktop';
        }
    }
    
    .primary-action-button {
        width: 221px;

        &:focus-visible {
            outline-offset: -1px !important;
        }
    }

    &__products {
        width: auto;
        display: grid !important;
        gap: 24px;
        grid-template-columns: 50% 50%;
        max-height: 860px;

        .card-product {
            height: auto;
            justify-content: flex-start;

            &__image {
                height: clamp(158px, 16.46vw, 237px);

                img {
                    height: auto;
                }

            }

            &__buttons {
                display: none;
            }
        }
    }
}
`